import { type CategoryFilter } from '@/features/state/lib/findingView'

export const CATEGORY_FILTER_LABEL: Record<CategoryFilter, string> = {
  all: 'All', secrets: 'Secrets', misconfigs: 'Misconfigs', exposure: 'Exposure',
}
/** 'all' is deliberately absent: it stays on the neutral accent. */
export const CATEGORY_FILTER_COLOR: Partial<Record<CategoryFilter, string>> = {
  secrets: 'var(--red)', misconfigs: 'var(--amber)', exposure: 'var(--blue)',
}
